"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const links_1 = require("../../utils/dom/links");
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const variables_1 = require("../../variables");
require("./Link.css");
exports.default = react_1.default.memo(function Link(_a) {
    var { target, rel } = _a, props = __rest(_a, ["target", "rel"]);
    const isLocal = (0, react_1.useMemo)(() => (0, links_1.isLocalLink)(props.href), [props.href]);
    const linkTarget = (0, react_1.useMemo)(() => (!target && !isLocal ? '_blank' : target || undefined), [isLocal, target]);
    const linkRel = (0, react_1.useMemo)(() => !isLocal ? TokenList_1.default.from(rel, 'noopener', 'noreferrer').value : rel, [isLocal, rel]);
    return (react_1.default.createElement("a", Object.assign({}, props, { className: TokenList_1.default.join([
            variables_1.StyleNamespace,
            'Link',
            (props.onClick || props.href) && 'Link--pointer',
            props.className,
        ]), target: linkTarget, rel: linkRel })));
});
